const CLASS_NAME_SHOW = 'show';
const CLASS_NAME_FADE = 'fade';

export { CLASS_NAME_FADE, CLASS_NAME_SHOW };
